import { Injectable } from '@angular/core';

import { UserRoleEnum } from '@enums/user-role.enum';
import { MenuItemInterface } from '../interfaces/menu-item.interface';
import { MENU_ITEMS_BY_ROLE } from '../properties/sidebar.properties';

@Injectable()
export class SidebarService {
  private readonly menuItemsByRole: Map<UserRoleEnum, MenuItemInterface[]> = MENU_ITEMS_BY_ROLE;

  /**
   * Get menu items for sidebar based on provided user role
   *
   * @param userRole - current user role
   */
  getMenuItemsByRole(userRole: UserRoleEnum): MenuItemInterface[] {
    return this.menuItemsByRole.get(userRole) ?? [];
  }
}
